// Shared bits for the drop planner screens: labels, colours, the API helper and small formatters.
// All the rules (dates, health, risks) live on the server in src/drops.js; the screens only show what it returns.

export const HEALTH = {
  on_track: { label: 'On track', variant: 'success' },
  at_risk:  { label: 'At risk',  variant: 'warning' },
  overdue:  { label: 'Overdue',  variant: 'destructive' },
  closed:   { label: 'Closed',   variant: 'outline' },
};
export const MILESTONE_STATE = {
  done:     { label: 'Done',     variant: 'success' },
  overdue:  { label: 'Overdue',  variant: 'destructive' },
  at_risk:  { label: 'At risk',  variant: 'warning' },
  on_track: { label: 'Planned',  variant: 'secondary' },
  skipped:  { label: 'Skipped',  variant: 'outline' },
};
export const DROP_STATUS = {
  planning:      'Planning',
  in_production: 'In production',
  ready:         'Ready to launch',
  live:          'Live',
  wrapped:       'Wrapped up',
  cancelled:     'Cancelled',
};
export const STYLE_STAGES = [
  { key: 'concept',         label: 'Concept',         short: 'Idea' },
  { key: 'tech_pack',       label: 'Tech pack',       short: 'Tech pack' },
  { key: 'sampling',        label: 'Sampling',        short: 'Sampling' },
  { key: 'sample_approved', label: 'Sample approved', short: 'Approved' },
  { key: 'production',      label: 'In production',   short: 'Making' },
  { key: 'received',        label: 'Received',        short: 'Received' },
  { key: 'photographed',    label: 'Photographed',    short: 'Shot' },
  { key: 'listed',          label: 'Listed',          short: 'Listed' },
  { key: 'live',            label: 'Live',            short: 'Live' },
];
export const PHASES = ['Concept', 'Develop', 'Source', 'Sample', 'Gate', 'Produce', 'Marketing', 'Logistics', 'Web', 'Launch', 'Wrap'];
export const OWNER_ROLES = ['Creative', 'Production', 'Marketing', 'Web', 'Ops', 'Go/no-go'];
export const MILESTONE_STATUSES = [
  { key: 'todo', label: 'Not started' }, { key: 'in_progress', label: 'In progress' }, { key: 'done', label: 'Done' }, { key: 'skipped', label: 'Skipped' },
];

export async function dropApi(method, url, body) {
  const res = await fetch(url, { method, credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export const fmtDate = (d, opts = { day: 'numeric', month: 'short', year: 'numeric' }) => (d ? new Date(`${d}T00:00:00Z`).toLocaleDateString('en-ZA', { ...opts, timeZone: 'UTC' }) : '—');
export const fmtShort = (d) => fmtDate(d, { day: 'numeric', month: 'short' });

/** "3 days late", "Today", "in 12 days". */
export function dueText(days) {
  if (days === null || days === undefined) return '';
  if (days < 0) return `${-days} day${days === -1 ? '' : 's'} late`;
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  return `in ${days} day${days === 1 ? '' : 's'}`;
}
/** "T-84" style label for a milestone, relative to the launch. */
export const tLabel = (offset) => (offset === 0 ? 'Launch day' : offset < 0 ? `${-offset} days before` : `${offset} days after`);
export const launchText = (days) => (days === null ? '' : days < 0 ? `launched ${-days} day${days === -1 ? '' : 's'} ago` : days === 0 ? 'launches today' : `${days} day${days === 1 ? '' : 's'} to launch`);
